// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hs","response":"Is","error":"Js","disabled":"Ks","buttons":"Ls","feedbackQuestionSection":"Ms","yesNoWrapper":"Ns"};